import _ from "lodash";
import { Layout } from "react-grid-layout";

import { IScreenByType } from "./../hooks/useMedia";
import { layoutInitials } from "./../store/layout/initials";
import { FieldTypes, IField } from "./../store/fields/types";
import { IDimension, ILayoutList, ILayoutState } from "./../store/layout/types";
import { IPage } from "./../store/pages/types";
import { getScreenType } from "./common";

export const getLayoutWithUpdatedWidths = (
    layout: ILayoutList,
    fields: IField[],
    screenType: IScreenByType,
    updatebleId?: IField["_id"],
    updateblevalue?: { [key: string]: any },
) => {
    let currentState: any = window["__current_form_state" as any];
    let boomformValues: { [kay: string]: any } = currentState.values.fields;
    if (updatebleId) boomformValues![updatebleId] = { ...boomformValues![updatebleId], ...updateblevalue };

    fields.forEach(({ type, _id }) => {
        let { minW, maxW } = layoutInitials[screenType][type];

        switch (type) {
            case FieldTypes.NAME:
                if (boomformValues[_id].isMiddleName) minW!++;
                break;
            case FieldTypes.TIME:
                if (updatebleId === _id) {
                    minW = updateblevalue!.minW;
                    layout[_id] = { ...layout[_id], w: updateblevalue!.w, minW: updateblevalue!.minW };
                }
                break;
        }

        layout[_id].minW = minW;
        layout[_id].maxW = maxW;

        if (layout[_id].w! < minW!) layout[_id].w = minW;
        if (layout[_id].w! > maxW!) layout[_id].w = maxW;
    });

    return _.cloneDeep(layout);
};

export const getLastLineOfLayout = (layout: ILayoutList) => {
    const layoutList = Object.values(layout);
    const lastRow =
        (layoutList &&
            layoutList.length > 0 &&
            Math.max(...layoutList.map((item = { y: 0, h: 0 }) => item.y! + item.h!))) ||
        0;
    return lastRow;
};

export const getNewFieldInitialLayoutByLayoutItem = (
    layout: ILayoutList,
    layoutItem: Layout,
    fieldId: IField["_id"],
    layoutInitial: IDimension,
) => {
    Object.keys(layout).forEach(key => {
        const { y } = layout[key];

        if (y && y >= layoutItem.y && layout[key].y !== undefined) layout[key].y = y + layoutItem.h;
    });

    layoutInitial.y = Number(layoutItem.y);

    return { ...layout, [fieldId]: { ...layoutInitial } };
};

export const getNewFieldInitialLayout = (
    layout: ILayoutList,
    fieldType: IField["type"],
    fieldId: IField["_id"],
    layoutItem: Layout | null,
) => {
    const screenType = getScreenType();
    const layoutInitial = layoutInitials[screenType][fieldType];
    if (layoutItem === null) {
        const lastRow = getLastLineOfLayout(layout);
        return { ...layout, [fieldId]: { ...layoutInitial, y: lastRow } };
    } else {
        return getNewFieldInitialLayoutByLayoutItem(layout, layoutItem, fieldId, layoutInitial);
    }
};

interface IIdData {
    fieldId: IField["_id"];
    tempId: IField["_id"];
    pageFieldsIds: IPage["fields"] | undefined;
}

type IGetNewLayoutWithAddedItem = (
    state: ILayoutState["list"],
    newItem: IDimension,
    idData: IIdData,
) => ILayoutState["list"];

export const getNewLayoutWithAddedItem: IGetNewLayoutWithAddedItem = (
    state,
    newItem,
    { fieldId, tempId, pageFieldsIds },
) => {
    let newState: ILayoutState["list"] = { ...state, [tempId]: newItem };

    let lastKey: IField["_id"] = "0";

    if (pageFieldsIds) {
        let list = [...pageFieldsIds, tempId].sort((aKey: IField["_id"], bKey: IField["_id"]) => {
            const aItem = newState[aKey];
            const bItem = newState[bKey];

            if (
                aItem &&
                aItem.x !== undefined &&
                aItem.y !== undefined &&
                bItem &&
                bItem.x !== undefined &&
                bItem.y !== undefined
            ) {
                if ((aItem.y! === bItem.y! && aItem.x! > bItem.x!) || aItem.y! > bItem.y!) {
                    return 1;
                }
                if ((aItem.y! === bItem.y! && aItem.x! < bItem.x!) || aItem.y! < bItem.y!) {
                    return -1;
                }
                if (aItem.x! === bItem.x! && aItem.y! === bItem.y!) {
                    if (tempId === aKey) return 1;
                    else if (tempId === bKey) return -1;
                }
            }

            return 0;
        });

        list.forEach((key: IField["_id"]) => {
            const layout = newState[key];

            if (lastKey === "0") {
                if (fieldId === key) lastKey = key;
            } else {
                const latItem = newState[lastKey];
                if (latItem) {
                    const newY = latItem.y! + latItem.h!;
                    newState[key] = { ...layout, y: newY };
                }

                lastKey = key;
            }
        });
    }

    return newState;
};
